import { GeorefData } from '../../../../../../store/uploadStore';
import { getStorageService } from '../../../../../../api_services/StorageService';
import { GeorefNotSetError } from '../../../../../../errors/GeorefNotSetError';
import { isCancelledByUserError } from '../../../../../../errors/createCanceledError';
import * as Sentry from '@sentry/browser';

export const uploadGeoref = async (
  file: File,
  customerId: string,
  siteId: string,
  getGeoRef: () => GeorefData | undefined,
  setGeoRef: (geoRef: GeorefData) => void,
  abortController: AbortController,
) => {
  const georef = getGeoRef();

  if (!georef) {
    throw new GeorefNotSetError();
  }

  try {
    await getStorageService().upload({
      signal: abortController.signal,
      customerId,
      siteId,
      uploadPath: georef.meta.georefUploadPath,
      file,
      onUploadProgress: (progressEvent) => {
        if (!abortController.signal.aborted) {
          const current = getGeoRef();
          if (current) {
            current.meta.uploadedSize = progressEvent.loaded;
            setGeoRef({
              ...current,
            });
          }
        }
      },
    });
  } catch (e: unknown) {
    if (isCancelledByUserError(e)) return null;
    Sentry.captureException(e);
    alert(`Couldn't upload georef for ${customerId} ${siteId}`);
    // @TODO Should probably show a toast or something like that here
  }
};
